<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{ formTitle }}</span>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md>
        <v-form ref="standardsForm" v-model="formValid">
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="delimiter_text">General info</h3>
            </v-flex>
            <v-flex xs12 sm6>
              <catValueDropDown
                :outlined="true"
                :catName="'RANK_CLASSIFICATION'"
                v-model.trim="standardData.classification"
                label="Classification"
                v-on:parentValListChange="onChangeClassification"
                :color="'blue'"
              />
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                class="hidden-xs-only"
                v-model.trim="standardData.setLibSetId"
                outlined
                dense
                item-color="primary"
                :items="events"
                item-value="node.eventId"
                cy-data="cy_Event_Standarts"
                :rules="requiredRule"
                label="Event"
                clearable
              >
                <template v-slot:item="data">
                  {{ data.item.node.distance }} {{ data.item.node.stroke }}
                </template>
                <template v-slot:selection="data">
                  {{ data.item.node.distance }} {{ data.item.node.stroke }}
                </template>
              </v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                v-model.trim="standardData.rankId"
                outlined
                dense
                :rules="requiredRule"
                item-color="primary"
                :items="filteredRanks"
                label="Ranks"
                item-value="node.rankId"
                item-text="node.rankName"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                v-model.trim="standardData.gender"
                outlined
                dense
                :rules="requiredRule"
                item-color="primary"
                :items="['male', 'female']"
                label="Gender"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                v-model.trim="standardData.facilityType"
                outlined
                dense
                :rules="requiredRule"
                item-color="primary"
                :items="catNames"
                item-text="node.valName"
                item-value="node.valName"
                label="Facility type"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                    type="text"
                    outlined
                    dense
                    hide-details
                    :rules="[requiredRule, timeFormatRule]"
                    v-model.trim="standardData.standardTime"
                    label="Standard Time (HH:mm:ss.SSS)"
                  ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                outlined
                dense
                v-model.trim="standardData.comments"
                label="Comments"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-menu
                v-model="effectiveDateModel"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model.trim="standardData.effectiveDate"
                    label="Effective date"
                    prepend-inner-icon="event"
                    outlined
                    dense
                    v-on="on"
                    v-bind="attrs"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model.trim="standardData.effectiveDate"
                  @input="effectiveDateModel = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" text @click="close">Close</v-btn>
      <v-btn :disabled="!formValid" color="secondary" text @click="actionName">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
/* eslint-disable prettier/prettier */
import { mapGetters, mapActions } from "vuex";
import { validation } from "../../mixins/validationMixin";
import catValueDropDown from "../shared/cat_val_dropdown.vue";

export default {
  components: { catValueDropDown },
  mixins: [validation],
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    editData: {
      type: [Boolean, Object],
    },
    events: {
      required: true,
    },
  },
  data() {
    return {
      formValid: true,
      effectiveDateModel: false,
      resultTime: "00:00:00.000",
      requiredRule: (v) => !!v || "This field is required.",
      timeFormatRule: (v) =>
        /^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])(\.\d{1,3})?$/.test(v) ||
        "Time must be in HH:mm:ss.SSS format.",      
      standardData: {
        setLibSetId: 0,
        rankId: 0,
        standardTime: "00:00:00.000",
        effectiveDate: new Date().toISOString().slice(0, 10),  // "YYYY-MM-DD"
        comments: "",
        gender: "",
        facilityType: "",
        classification: "",
        updateSource: "test",
      },
      //TODO Take out this data
      defaultData: {
        setLibSetId: 0,
        rankId: 0,
        standardTime: "00:00:00.000",
        effectiveDate: new Date().toISOString().slice(0, 10),  // "YYYY-MM-DD"
        comments: "",
        gender: "",
        facilityType: "",
        classification: "",
        updateSource: "test",
      },
    };
  },
  methods: {
    ...mapActions(["mergeStandard", "deleteStandard", "updateStandard"]),
    close() {
      this.standardData = Object.assign({}, this.defaultData);
      this.$emit("close-form");
    },
    addNewStandard() {
      this.$emit("set-loading", true);
      if (this.formValid) {
      //  this.standardData.setLibSetId = this.standardData.setLibSetId;
        // this.standardData.rankId = +this.standardData.rankId;
        this.mergeStandard(this.standardData)
          .then(() => {
            this.$emit("set-loading", false);
            this.$toast.success("New standard has been added");
//            this.close();
          })
          .catch((error) => {
            if (String(error.message).includes("duplicated")) {
              this.$toast.error("Standard with current data is already exist");
            }
            console.error(error);
            this.$emit("set-loading", false);
            this.close();
          });
      } else {
        this.$emit("set-loading", false);
        this.$toast.error("Form doesn't valid");
        this.validateForm("standardsForm");
      }
    },
    /**
     * @param {Object || boolean}
     */
    setStandardData(data) {
      if (data) {
        //console.log(data);
        this.standardData = { ...this.defaultData, ...data };
        // this.standardData.setLibSetId = this.сheckOldValue("set_lib_set_id", true);
        // this.standardData.standardTime = this.сheckOldValue("standard_time", false);
       // console.log(this.standardData);
      }
    },
    /**
     * @param {String} oldValue
     * @param {Boolean} convertToNumber
     */
    //TODO Take out this logic to helper file
    // сheckOldValue(oldValue, convertToNumber) {
    //   if (this.standardData.hasOwnProperty(oldValue)) {

    //     if (
    //       typeof this.standardData[oldValue] === "string" &&
    //       this.standardData[oldValue].length > 0
    //     ) {
    //       if (convertToNumber) {
    //         return Number(this.standardData[oldValue]);
    //       }

    //       return this.standardData[oldValue];
    //     } else if (typeof this.standardData[oldValue] === "number") {
    //       return this.standardData[oldValue];
    //     } else {
    //       console.warn(
    //         "checkOldValue method accepts only number or string args"
    //       );
    //       return this.standardData[oldValue];
    //     }
    //   } else {
    //     console.warn("No current value in obj");
    //     return false;
    //   }
    // },
    checkOldValue(oldValue, convertToNumber) {
      if (Object.prototype.hasOwnProperty.call(this.standardData, oldValue)) {
        if (
          typeof this.standardData[oldValue] === "string" &&
          this.standardData[oldValue].length > 0
        ) {
          if (convertToNumber) {
            return Number(this.standardData[oldValue]);
          }

          return this.standardData[oldValue];
        } else if (typeof this.standardData[oldValue] === "number") {
          return this.standardData[oldValue];
        } else {
          console.warn(
            "checkOldValue method accepts only number or string args"
          );
          return this.standardData[oldValue];
        }
      } else {
        console.warn("No current value in obj");
        return false;
      }
    },

    editStandard() {
      this.$emit("set-loading", true);
      if (this.formValid) {
        if (this.standardData.standardId) {
          this.standardData.standardId = +this.standardData.standardId;
        }
        //console.log(this.standardData);
        this.updateStandard(this.standardData)
          .then(() => {
            this.$emit("set-loading", false);
            this.$toast.success("Standard has been updated");
            this.close();
          })
          .catch((error) => {
            console.error(error);
            this.$emit("set-loading", false);
            this.close();
          });
      } else {
        this.$emit("set-loading", false);
        this.$toast.error("Form doesn't valid");
        this.validateForm("standardsForm");
      }
    },
    onChangeClassification(newClassification) {
      this.standardData.classification = newClassification;
      this.standardData.rankId = null; // clear selected rank
    },
  },
  mounted() {
    // ? Mounted hook can catch first update of editData
    this.setStandardData(this.dataToEdit);
  },
  watch: {
    dataToEdit() {
      this.setStandardData(this.dataToEdit);
    },
  },
  computed: {
    ...mapGetters(["rankLib", "categoryValue"]),
    filteredRanks() {
      if (!this.standardData.classification) return this.rankLib.edges;
      return this.rankLib.edges.filter(
        (edge) =>
          edge.node.rankClassification === this.standardData.classification
      );
    },
    /**
     * @return {Object || Boolean}
     */
    dataToEdit() {
      if (this.editData && typeof this.editData !== "boolean") {
        return this.editData;
      } else {
        return false;
      }
    },
    catNames() {
      return (
        this.categoryValue.edges.filter((c) =>
          c.node.category.catName.includes("SWIMMING_FACILITY")
        ) || []
      );
    },
    actionName() {
      return this.index > 0 ? this.editStandard : this.addNewStandard;
    },
  },
};
</script>